import http from "../httpService";
import {getBaseUrl} from "../../config";


export const getDegree = id => {
  return http.get(
    `${getBaseUrl()}/degree/${id}`
  );
};

export const getDegrees = (paginate) => {
  if (!paginate) {
    return http.get(
      `${getBaseUrl()}/degree`
    );
  }
  return http.get(
    `${getBaseUrl()}/degree?${paginate}`
  );
};

export const updateDegree = data => {

  return http.put(
    `${getBaseUrl()}/degree/${data.id}`,
    data
  );
};
export const submitDegree = data => {

  return http.post(
    `${getBaseUrl()}/degree`,
    data
  );
};
